import { PresentationSlide, SlideObject } from '../types';

function layoutHasObjects(layout: { objects?: unknown[] }): boolean {
  return Array.isArray(layout.objects) && layout.objects.length > 0;
}

export function layoutPreviewSlide(
  templateId: string,
  layout: { layoutId: string; objects?: SlideObject[]; backgroundColor?: string },
): PresentationSlide {
  return {
    slideId: `${templateId}:${layout.layoutId}`,
    presentationId: templateId,
    order: 0,
    layoutId: layout.layoutId,
    objects: layout.objects || [],
    notes: '',
    backgroundColor: layout.backgroundColor || '#FFFFFF',
  };
}

export function filterTemplates<T extends { name: string }>(templates: T[], query: string): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return templates;
  return templates.filter((template) => template.name.toLowerCase().includes(needle));
}

export function filterLayouts<T extends { name: string }>(layouts: T[], query: string): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return layouts;
  return layouts.filter((layout) => layout.name.toLowerCase().includes(needle));
}

/** Skip leftover empty layouts when the mall already has drawn pages. */
export function layoutsForNewPage<T extends { objects?: unknown[] }>(layouts: T[] | undefined): T[] {
  const list = layouts || [];
  const drawn = list.filter(layoutHasObjects);
  return drawn.length ? drawn : list;
}

export function previewLayout<T extends { objects?: unknown[] }>(layouts: T[] | undefined): T | undefined {
  const list = layouts || [];
  return list.find(layoutHasObjects) || list[0];
}
